module.exports = __webpack_public_path__ + "static/img/open.4b037f69.png";